import { createAction, props } from '@ngrx/store';
import { ResponseBadRequest } from '@core/interfaces';
import { Idioma } from '@core/models';

export const LANGUAGE_FIND = createAction('[Language] Find', props<{ language: string }>());
export const LANGUAGE_FIND_SUCCESS = createAction('[Language] Find Success', props<{ language: string; translations: Idioma }>());

export const LANGUAGE_FAILURE = createAction('[Language] Failure', props<{ error: ResponseBadRequest }>());

export const LANGUAGE_CHANGE = createAction('[Language] Change', props<{ language: string }>());
export const LANGUAGE_UPDATE_LOADING = createAction('[Language] Update Loading', props<{ loading: boolean }>());

export const LANGUAGE_RESET = createAction('[Language] Reset');
export const LANGUAGE_RESET_ERROR = createAction('[Language] Reset Error');
export const LANGUAGE_CLEAR_STATE = createAction('[Language] Clear State');